export default __webpack_public_path__ + "static/media/CloseIcon.0181546d.svg";